import React, { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import FeedbackPanel from "./FeedbackPanel";
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            staleTime: Infinity,
            // Do not retry since Axios already has retry policy set
            retry: false,
        },
    },
});
export const Feedback = () => {
    useEffect(() => function clearCache() {
        queryClient.clear();
    }, []);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(FeedbackPanel, null)));
};
